import { css } from '@emotion/react';

const customStyles = css`


  ul {
    color: #020509B3
  }

//header部分样式

  .navBarWrapper {
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 99;
    background: black;
    display: flex;
    justify-content: center;
    height: 84px;
  }

  .navBarDefault {
    postition: relative;
    right: 486px;
    padding-left: 110px;
  }

  .navBarDefault {
    background: black;
    color: white;
    // padding-top: 23px;
    display: flex;
    flex-flow: wrap;
  }

  .nav-btn-wrapper {
    position: sticky;
    height: calc(100vh - 210px);
    width: 1px;
    top: 128px;
  }
  .nav-btn-wrapper button {
    margin-left:-220px;
    width: 58px;
    height: 48px;
    color: #0D84FF;
    background: rgba(13, 132, 255, 0.03);
    border-radius: 16px;
    border: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 20px;
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    float: left;
    -webkit-transition: border 0.1s ease-out 0s;
    transition: border 0.1s ease-out 0s;
  }

  .nav-btn-wrapper button:hover {
    border: 2px solid #0C77E5;
  }

  table {
    display: table;
    border: 1px solid #ddd;
    margin-bottom: 6px;
    box-sizing: border-box;
    text-indent: initial;
    border-spacing: 0px;
    border-collapse:collapse;
    width: 100%;
  }

  main svg {
    width: 100%;
    height: auto;
  }

  .nav-btn-wrapper button img {
    position: static;
    width: 18px;
    height: 15px;
    left: calc(50% - 18px/2 - 51.5px);
    top: 6px;
    margin: 0 10px;
    max-width: none;
  }

  .middle>div{
    min-height: calc(100vh - 166px);
    justify-content: center;
    display: flex;
    positive: relative;
  }

  .titleWrapper h1{
    border: none;
    font-family: MiSans;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 50px;
  }

  hr {
    height: 2px;
    background-color: rgba(2, 5, 9, 0.09);
    border: 0;
  }

  .comment-wrapper {
    padding: 30px;
    background: rgba(13, 132, 255, 0.03);
    border-radius: 16px;
    margin: 40px 0 60px;
  }

  .comment-wrapper .container {
    width: 70px;
    height: 24px;
    vertical-align: middle;
  }

  .comment-wrapper svg {
    width: 20px;
    height: 20px;
  }

  .comment-wrapper .title {
    display: inline-block;
    float: right;
    margin-right: 5px;
    font-family: MiSans;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: #020509;
  }
  .comment-wrapper .content {
    margin-top: 10px;
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: rgba(2, 5, 9, 0.7);
  }


//上下篇文章按钮样式

  .addPaddTopBottom {
    margin-bottom: 30px;
  }

  // .preRightWrapper {
  //   text-align: left;
  // }

  .nextBtn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 24px;
    position: static !important;
    height: 108px;
    left: 740px;
    top: 0px;
    background: rgba(2, 5, 9, 0.03) !important;
    border-radius: 16px;
    text-align: right;
  }

  //上一篇文章按钮样式

  .previousBtn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 24px;
    position: static !important;
    height: 108px;
    left: 270px;
    top: 0px;
    background: rgba(2, 5, 9, 0.03) !important;
    border-radius: 16px;
  }

  //底部区域样式
  .footer {
    display: flex;
    background: #000000;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 40px 38px;
  }

  .law-section {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  //链接样式
  .links {
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
  }

  .links a{
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.8);
  }

  .links a:hover{
    color: rgba(255, 255, 255, 1.0);
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }

  .links a:active{
    color: rgba(255, 255, 255, 0.9);
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }

  .links a:first-child::before {
    padding: 0;
    content: '';
  }

  //链接分隔符样式

  .divider {
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.8);
  }

  //footer标签最后一行样式

  .bottom {
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    margin-top: 6px;
    color: rgba(255, 255, 255, 0.6);
    word-wrap:break-word;
  }

  .paragraph {
    font-family: MiSans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    margin-bottom: 16px;
    align-items: center;
    color: rgba(2, 5, 9, 0.7);
  }

  //md文件底部段落样式

  .paragraph a {
    color: #0d84ff !important;
    // margin: 0; 
  }

  .paragraph:last-child {
    // margin: 0;
  }

  //左侧路由导航样式调整

  .sideBarUL {
    position: relative;
    top: 0px;
  }

  //修改导航栏图标大小及间距问题

  .navBarBrand img {
    // width: 240.16px;
    height: 34px;
    position: static;
    left: 48px;
    top: 24px;
    transform: scale(1.2);
  }

  .removePadd {
    position: fixed;
    height: 1px;
    right: 0px;
    top: 0px;
    width: 1px;
    padding-left: 1px !important;
  }

  .navBarToggle:focus {
    outline: none
  }

  .hideFrontLine ul:first-child {
    border-top: 2px solid rgba(2, 5, 9, 0.09);
    padding-top: 12px;
  }
  .iconbar{
    width: 15px;
    height: 15px;
  }
  .iconBar:last-child {
    // width: 15px;
  }
  .img-responsive displayInline1 {
    transform: scale(0.8);
  }

  //表格容器样式,可滑动,隐藏滚动条
  .coltable {
    overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  
  }

  //隐藏滚动条
  .coltable::-webkit-scrollbar { 
    width: 0 !important;
  }

  //序号标志颜色
  ::marker {
  color: rgba(2, 5, 9, 0.7);
  }

  //index.mdx页面布局

  .colHomeleft {
    display: grid;
    grid-template-columns: 1fr 150px;
    column-gap: 20px;
    margin-bottom: 10px;
  }

  .colHomeright {
    display: grid;
    grid-template-columns: 150px 1fr;
    column-gap:20px;
    margin-bottom: 10px;
  }

  .colImg{  
    display: flex;  
  }

  .colImg > svg{    
    display: flex;
    margin: auto;
    align-items: center;
  }

  .homeBtn {
    cursor: pointer;
    -moz-box-align: center;
    -moz-box-direction: normal;
    -moz-box-orient: horizontal;
    margin: 20px 0 0 0;
    padding: 10px 20px;
    width: max-content;
    display: grid;
    grid-template-columns: 1fr 7px;
    column-gap: 10px;
    border-radius: 16px;
    border: 1.5px solid rgba(13, 132, 255,0.03);
    text-decoration: none;
    background-color: rgba(2, 5, 9, 0.03);
    color: rgba(2,5,9,0.7) !important;
    -webkit-transition: 0.2s !important;
    transition: 0.2s !important;
  } 

  .homeBtn:hover {
    text-decoration: none;
    border: 1.5px solid #0D84FF;
    background-color: rgba(2, 5, 9, 0.03);
    // color: #0d94ff! important;
    -webkit-transition: 0.2s !important;
    transition: 0.2s !important;
  }

@media (max-width: 767px) {
  .colHomeright{
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 30px;
    margin: auto;
    text-align: center;
  }
  .colHomeleft{
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 30px;
    margin: auto;
    text-align: center;
  }
  .colImg{  
    display: block;
    width: 200px;
    height: 160px;
    margin: auto;
  }
  .colImg > svg{
    display: block;
  }
  .homeBtn {
    cursor: pointer;
    -moz-box-align: center;
    -moz-box-direction: normal;
    -moz-box-orient: horizontal;
    margin: 20px auto 0 auto;
    padding: 10px 20px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 7px;
    column-gap: 10px;
    border-radius: 16px;
    border: 1.5px solid rgba(13, 132, 255,0.03);
    text-decoration: none;
    background-color: rgba(2, 5, 9, 0.03);
    color: rgba(2,5,9,0.7) !important;
    -webkit-transition: 0.2s !important;
    transition: 0.2s !important;
  } 
  .homeBtn:hover {
    text-decoration: none;
    border: 1.5px solid #0D84FF;
    background-color: rgba(2, 5, 9, 0.03);
    // color: #0d94ff! important;
    -webkit-transition: 0.2s !important;
    transition: 0.2s !important;
  }
}

//图片和内容布局选项

.colMobile{
  display: none;
}
.colPC{
  display: block;
}
.colFigure {
  display: block;
  margin: auto;
  width: 600px;
  padding: 10px 0;
}
.colFigure2 {
  display: block;
  margin: auto;
  width: 400px;
  padding: 10px 0;
}
.colIcon {
  display: block;
  width: 180px;
  padding: 10px 0;
}
.colTwo {
  display: grid;
  column-gap:30px;
  padding-bottom: 30px;
  padding-top: 20px;
  grid-template-columns: 0.5fr 0.5fr;
}

//550以下显示特殊布局
@media (max-width: 550px) {
  .colMobile{
    display: block;
  }
  .colPC{
    display: none;
  }
}
//767下两栏竖排
@media (max-width: 767px) {
.colTwo {
  display: grid;
  grid-template-columns: 1fr !important;
  row-gap: 30px;
}
.colFigure {
  display: block;
  width: auto;
}
.colFigure2 {
  display: block;
  width: auto;
}
}
`;

export const styles = [customStyles];
